import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { LocalidadIDE } from './entity-localidades-ide.model';

export const entityLocalidadesIDEAdapter: EntityAdapter<LocalidadIDE> =
  createEntityAdapter<LocalidadIDE>({
    selectId: (model) => model.id,
    sortComparer: (a: LocalidadIDE, b: LocalidadIDE): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityLocalidadesIDEState extends EntityState<LocalidadIDE> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityLocalidadesIDEState =
  entityLocalidadesIDEAdapter.getInitialState({
    isLoading: false,
    error: null
  });
